import React from 'react';
import { Countdown } from './Countdown';
import { TrustBadges } from './TrustBadges';
import { FadeIn } from './FadeIn';
import { ChevronRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[100svh] flex flex-col justify-center items-center px-4 py-6 overflow-hidden" data-id="element-73">
      {/* Background track lines effect */}
      <div className="absolute inset-0 opacity-5 pointer-events-none flex justify-center" data-id="element-74">
        <div className="w-full max-w-5xl h-full relative" data-id="element-75">
          {[...Array(6)].map((_, i) => <div key={i} className="absolute top-0 bottom-0 border-l border-running-blue" style={{
          left: `${(i + 1) * 16.66}%`
        }} data-id="element-76" />)}
          <div className="absolute bottom-1/4 left-0 right-0 border-t-2 border-running-blue rounded-full" data-id="element-77" />
        </div>
      </div>

      {/* Blue glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-running-blue/5 rounded-full blur-[120px] pointer-events-none" data-id="element-78" />

      <div className="max-w-4xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-79">
        <FadeIn data-id="element-80">
          <span className="inline-block bg-running-surface border border-running-muted text-gray-300 text-[10px] sm:text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-3" data-id="element-81">
            Stock Digital™
          </span>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-82">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black text-white mb-2 leading-[0.95] tracking-tight uppercase text-balance" data-id="element-83">
            Transformá vidas con el running.{' '}
            <span className="text-running-blue drop-shadow-[0_0_30px_rgba(61,232,255,0.4)]" data-id="element-84">
              Empezá hoy.
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-85">
          <p className="text-lg sm:text-2xl md:text-3xl font-display font-bold text-running-blue mb-3 uppercase tracking-tight" data-id="element-86">
            Con el Mega Pack Running.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-87">
          <p className="text-sm sm:text-lg text-gray-300 font-medium mb-4 max-w-2xl mx-auto leading-snug text-balance" data-id="element-88">
            Si sos profe de running y todavía improvisás tus planes semana a
            semana, esto es exactamente lo que necesitás.
          </p>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-89">
          <div className="w-full mx-auto mb-4 flex items-center justify-center" data-id="element-90">
            <img src="https://cdn.magicpatterns.com/uploads/1Qr5qoyZKAMHgqqg8GePzp/heylloyd-generated-1782180747539.png" alt="Mega Pack Running — coleccion completa de tomos del sistema" className="w-auto max-h-[28vh] sm:max-h-[34vh] max-w-full object-contain drop-shadow-[0_20px_60px_rgba(61,232,255,0.25)]" data-id="element-91" />
          </div>
        </FadeIn>

        <FadeIn delay={0.3} className="flex flex-col items-center gap-3 sm:gap-4 w-full" data-id="element-92">
          <Countdown data-id="element-93" />
          <a href="#pricing" className="w-full sm:w-auto bg-running-blue hover:bg-running-blueHover text-running-dark font-display rounded-xl px-8 sm:px-10 py-3 sm:py-4 flex flex-col items-center justify-center transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_30px_rgba(61,232,255,0.25)]" data-id="element-94">
            <span className="flex items-center gap-2 font-black text-lg sm:text-2xl leading-none" data-id="element-95">
              VER LA OFERTA
              <ChevronRightIcon className="w-5 h-5 sm:w-7 sm:h-7" strokeWidth={3} data-id="element-96" />
            </span>
            <span className="font-bold text-sm sm:text-base text-running-dark/80 mt-1" data-id="element-97">
              <span className="line-through opacity-60 mr-1.5" data-id="element-98">$120.000</span>
              $19.990
            </span>
          </a>
          <TrustBadges data-id="element-99" />
        </FadeIn>
      </div>
    </section>;
}